module.exports = __webpack_public_path__ + "img/logo_6.0f4b4b2a.png";